async = require('../../../../core/frontend/vendor_modules/async')
SharedUser = require('../../../shared/frontend/helpers/user')
SupportAjaxShimTemplate = require('../../ajax_shim.html.mustache')

callWasInterrupted = (status, errorMessage) ->
  status == 'abort' || !errorMessage? || errorMessage?.length == 0

SupportAPIHelper =
  httpErrorHandler: (response, status, errorMessage) =>
    return if callWasInterrupted(status, errorMessage)
    flash('error', 'Sorry something went wrong')
    $('#g-spinner').hide()

  errorHandler: (errorMessage) ->
    flash('error', errorMessage)

  parallel: (urls, datas, responseCallback, blockUI, timer, timeout, methods = []) ->
    successCb = (cb) ->
      (response) =>
        cb null, response

    errorCb = (cb) ->
      (errorMessage) =>
        cb null, null

    requests  = []
    callbacks = []
    _.each urls, (url, index) =>
      callbacks.push(
        (cb)=>
          if methods[index]?
            req = @call url, methods[index], datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout
          else
            req = @get url, datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout
          requests.push req
      )

    async.parallel callbacks, (err, results) =>
      if err?
        return responseCallback null
      responseCallback results
    requests

  get: (url, data, success, error, blockUI, timer = null, timeout = 70000) ->
    args = Array.prototype.slice.call(arguments)

    switch args.length
      when 2
        success = data
        data = undefined
      when 3
        if typeof(args[1]) == 'function'
          error = success
          success = data
          data = undefined
    return @call(url, 'GET', data, success, error, blockUI, timer, timeout)

  call: (url, method, data, successHandler, customErrorHandler, blockUI, timer = null, timeout = 70000) ->
    data ||= {}

    switch method
      when 'PUT'
        method = 'POST'
        data._method = 'PUT'
      when 'DELETE'
        method = 'POST'
        data._method = 'DELETE'
    if blockUI
      ajaxShimTemplate = SupportAjaxShimTemplate.render({})
      $('body').append(ajaxShimTemplate)

    options =
      url: url
      type: method
      dataType: 'json'
      headers: {}
      timeout: timeout
      data: data
      error: (err, status, errorMessage) =>
        stopTimer(timer) if timer?
        $('.ajaxshim').remove() if blockUI
        if customErrorHandler
          customErrorHandler(errorMessage)
        else
         @httpErrorHandler(err, status, errorMessage)
      success: (response) =>
        stopTimer(timer) if timer?
        $('.ajaxshim').remove()
        if !response || response.length == 0 || response.error?
          if customErrorHandler?
            customErrorHandler(response)
          else
            @errorHandler(null)
        else
          successHandler(response)

    SharedUser.setGrpnUsrHeader(options)

    startTimer(timer) if timer?
    request = $.ajax(options)
    request

module.exports = SupportAPIHelper
